module.exports = __webpack_public_path__ + "static/luciernaga@2x-315cbdfd9da6ce8feff065dc606ed537.png";